
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import PartContainer from "./PartContainer.vue";
import { DraggingContext, Part, Parts } from "../types";
import { ensureTargetElement } from "./helper";
import ImageShape from "./shapes/ImageShape.vue";
import RectangleShape from "./shapes/RectangleShape.vue";

Vue.component(ImageShape.name, ImageShape);
Vue.component(RectangleShape.name, RectangleShape);

@Component({
    name: "parts-chooser",
    components: { PartContainer },
})
export default class PartsChooser extends Vue {
    @Prop({ type: Object }) template!: webpartv3.WebpartTemplate;
    @Prop({ type: Array }) parts!: Parts;
    @Prop({ type: Object }) dragging!: DraggingContext;
    @Prop({ type: Boolean, default: false }) personal!: boolean;

    dX: number = 0;
    dY: number = 0;
    /**
     * 마우스로 끌고(Drag) 있는 HTML Element
     */
    dragElement: HTMLElement | null = null;
    /**
     * 검색 키워드
     */
    keyword: string = "";
    /**
     * 정렬 방법
     */
    sortMethod: "asc" | "desc" = "asc";

    /**
     * 검색 키워드로 필터링된 Parts를 조회
     */
    get filteredParts() {
        const { keyword, parts } = this;
        if (this.template.isDefault) {
            if (this.personal) {
                parts.map((p) => {
                    if (p.roles && p.roles.length > 0) p.available = false;
                });
            }
        }
        let p: Parts;
        if (keyword) {
            p = parts.filter((part) => {
                return part.enabled && part.title.indexOf(keyword) >= 0;
            });
        } else {
            p = parts.filter((part) => {
                return part.enabled;
            });
        }
        const method = this.sortMethod;
        let func: (a: Part, b: Part) => number;
        if (method === "asc") {
            func = function compare(a: Part, b: Part) {
                if (a.title < b.title) return -1;
                if (a.title > b.title) return 1;
                return 0;
            };
        } else {
            func = function compare(a: Part, b: Part) {
                if (a.title < b.title) return 1;
                if (a.title > b.title) return -1;
                return 0;
            };
        }
        return p.sort(func);
    }

    getTitle(part: Part) {
        const { isFixedSize, fixedColcnt, fixedRowcnt, title, titleEn } = part;
        var value = "";
        if (isFixedSize) {
            value = `[${fixedColcnt}x${fixedRowcnt}] `;
        }
        value += title;
        return value;
    }

    handleToggleSort() {
        this.sortMethod = this.sortMethod === "asc" ? "desc" : "asc";
    }

    mousedown(part: Part, e: MouseEvent) {
        var target = ensureTargetElement(e.target as HTMLElement);
        let cs = document.defaultView?.getComputedStyle(target);
        let bounds = target.getBoundingClientRect();

        this.dX = bounds.left - e.clientX;
        this.dY = bounds.top - e.clientY;

        this.dragElement = target;
        this.dragElement.style.width = parseFloat(cs!.width) + "px";
        this.dragElement.style.height =
            //@ts-ignore
            this.dragElement.parentElement!.style!.height = parseFloat(cs!.height) + "px";

        this.dragMove(e);

        document.documentElement.addEventListener("mousemove", this.dragMove, false);
        document.documentElement.addEventListener("mouseup", this.dragStop, false);
        document.documentElement.addEventListener("keydown", this.keyDown, false);

        this.dragging.active = true;
        this.dragging.cancelled = false;
        this.dragging.id = part.webpartId;
        this.dragging.part = part;
    }

    keyDown(e: KeyboardEvent) {
        // Dragging 중에 ESC 키를 누른 경우 드레깅 취소
        if (e.key === "Escape") {
            this.dragging.cancelled = true;
            this.dragStop();
        }
    }

    dragMove(e: MouseEvent) {
        if (this.dragElement) {
            this.dragElement.style.left = e.clientX + this.dX + "px";
            this.dragElement.style.top = e.clientY + this.dY + "px";
        }
    }

    dragStop() {
        document.documentElement.removeEventListener("mousemove", this.dragMove, false);
        document.documentElement.removeEventListener("mouseup", this.dragStop, false);
        document.documentElement.removeEventListener("keydown", this.keyDown, false);

        if (this.dragElement) {
            //@ts-ignore
            this.dragElement.parentElement.removeAttribute("style");
            this.dragElement.removeAttribute("style");
            this.dragElement = null;
        }

        this.dragging.active = false;
    }
}
